import React, {
    useState,
    useCallback,
    useEffect,
    useMemo,
} from "react";

import {
    GoogleMap,
    MarkerF,
    InfoWindowF,
    useLoadScript,
} from "@react-google-maps/api";

import { Link } from "react-router-dom";

const mapContainerStyle = {
    width: "100%",
    height: "650px",
};

const grayStyles = [
    {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#686868" }],
    },
    {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
    },
    {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
    },
    {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
    },
    {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#b7e4f4" }, { visibility: "on" }],
    },
];

const MapComponent = ({
    activeTab,
    activeSubTab,
    localAddress = false,
    markerColor
}) => {

    const [isLoading, setIsLoading] = useState(true);

    const [projectsData, setProjectsData] = useState([]);

    // ======================================================
    // FETCH DATA
    // ======================================================

    const getAllData = async () => {

        try {

            setIsLoading(true);

            const response = await fetch(
                "https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&populate[Standort][populate]=*&populate[Beitrags_Miniaturbild][populate]=true&populate[neubauprojekte_kategoriens][populate]=*&populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true"
            );

            const json = await response.json();

            setProjectsData(json?.data || []);

        } catch (error) {

            console.error(error);

        } finally {

            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllData();
    }, []);

    // ======================================================
    // GOOGLE MAP
    // ======================================================

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey:
            "AIzaSyApQjBO96fzVzx23FBn8_62gGIfpd0ijrY",
        libraries: ["places"],
    });

    const [activeMarker, setActiveMarker] =
        useState(null);

    const [icon, setIcon] = useState(null);

    // ======================================================
    // CATEGORY HELPERS
    // ======================================================

    const getCategoryData = (item) => {

        return (
            item?.neubauprojekte_kategoriens?.map(
                (cat) => {

                    const fullTitle =
                        cat?.Titel
                            ?.toLowerCase()
                            ?.trim() || "";

                    const [
                        category,
                        subcategory,
                    ] = fullTitle
                        .split(" - ")
                        .map((v) => v?.trim());

                    return {
                        category,
                        subcategory,
                        fullTitle,
                    };
                }
            ) || []
        );
    };

    // ======================================================
    // FILTER + LOCATIONS
    // ======================================================

    const locations = useMemo(() => {

        let filtered = [];

        // ==================================================
        // ALLE
        // ==================================================

        if (activeTab === "alle") {

            filtered = projectsData;
        }

        // ==================================================
        // OTHER TABS
        // ==================================================

        else {

            const tab = activeTab?.toLowerCase()?.trim();
            const subTab = activeSubTab?.toLowerCase()?.trim();

            filtered = projectsData?.filter(
                (item) => {

                    const categories =
                        getCategoryData(item);

                    // 👉 category match
                    const hasCategory =
                        categories?.some(
                            (cat) =>
                                cat.category?.toLowerCase()?.trim() ===
                                tab
                        );

                    if (!hasCategory)
                        return false;

                    // 👉 subcategory match
                    // if (
                    //     activeSubTab ===
                    //     "alle" ||
                    //     !activeSubTab
                    // ) {

                    //     return true;
                    // }

                    if (subTab === "alle" || !subTab) {
                        return true;
                    }

                    // return categories?.some(
                    //     (cat) =>
                    //         cat.category ===
                    //         activeTab &&
                    //         cat.subcategory ===
                    //         activeSubTab
                    // );
                    return categories?.some(
                        (cat) =>
                            cat.category?.toLowerCase()?.trim() === tab &&
                            cat.subcategory?.toLowerCase()?.trim() === subTab
                    );
                }
            );
        }

        // ==================================================
        // MAP DATA
        // ==================================================

        return filtered
            ?.map((item) => {

                const latitude =
                    item?.Standort?.latitude;

                const longitude =
                    item?.Standort?.longitude;

                if (
                    !latitude ||
                    !longitude
                ) {

                    return null;
                }

                return {

                    id: item?.id,

                    lat: parseFloat(latitude),

                    lng: parseFloat(longitude),

                    image:
                        item
                            ?.Beitrags_Miniaturbild
                            ?.url
                            ? `https://backend.bgzurlinden.ch${item?.Beitrags_Miniaturbild?.url}`
                            : null,

                    address:
                        item?.Page_Titel ||
                        "No title",

                    description:
                        item?.Standort?.Text || "",

                    Titel_Text: item?.Standort?.Titel_Text || "",

                    pageTemplate:
                        item?.Page_Template || null,

                    slug:
                        item?.slug || null,
                };
            })
            ?.filter(Boolean);

    }, [
        projectsData,
        activeTab,
        activeSubTab,
    ]);

    // ======================================================
    // ICON
    // ======================================================

    useEffect(() => {

        if (
            isLoaded &&
            window.google
        ) {

            setIcon({
                url: markerColor === "blue" ? "https://backend.bgzurlinden.ch/uploads/mappin_blue_6e5bf52ffe.svg" : "https://backend.bgzurlinden.ch/uploads/Group_1597880547_824772d26d.svg",
            });
        }

    }, [isLoaded]);

    // ======================================================
    // MAP FIT BOUNDS
    // ======================================================

    // const onMapLoad = useCallback(
    //     (map) => {

    //         if (!locations?.length)
    //             return;

    //         // 👉 single marker
    //         if (
    //             locations.length === 1
    //         ) {

    //             map.setCenter({
    //                 lat: locations[0].lat,
    //                 lng: locations[0].lng,
    //             });

    //             map.setZoom(16);

    //             return;
    //         }

    //         // 👉 multiple markers
    //         const bounds =
    //             new window.google.maps.LatLngBounds();

    //         locations.forEach((loc) => {

    //             bounds.extend({
    //                 lat: loc.lat,
    //                 lng: loc.lng,
    //             });
    //         });

    //         map.fitBounds(bounds);

    //     },
    //     [
    //         locations,
    //         activeTab,
    //         activeSubTab,
    //     ]
    // );
    const [map, setMap] = useState(null);

    const onMapLoad = useCallback((mapInstance) => {
        setMap(mapInstance);
    }, []);

    const fitMapToLocations = useCallback(() => {
        if (!map || !locations?.length || !window.google) return;

        // Single marker
        if (locations.length === 1) {
            map.setCenter({
                lat: locations[0].lat,
                lng: locations[0].lng,
            });

            map.setZoom(16);
            return;
        }

        // Multiple markers
        const bounds = new window.google.maps.LatLngBounds();

        locations.forEach((loc) => {
            bounds.extend({
                lat: loc.lat,
                lng: loc.lng,
            });
        });

        map.fitBounds(bounds, {
            top: 80,
            right: 80,
            bottom: 80,
            left: 80,
        });
    }, [map, locations]);

    useEffect(() => {
        fitMapToLocations();
    }, [fitMapToLocations]);

    // ======================================================
    // STATES
    // ======================================================

    if (loadError) {
        return (
            <p>
                Error loading maps
            </p>
        );
    }

    if (
        !isLoaded ||
        isLoading ||
        !icon ||
        locations.length === 0
    ) {

        return (
            <div
                style={{
                    width: "100%",
                    height: "650px",
                    display: "flex",
                    alignItems:
                        "center",
                    justifyContent:
                        "center",
                    background:
                        "#f5f5f5",
                    borderRadius:
                        "12px",
                }}
            >
                <div className="map-loader">
                    <div className="spinner"></div>
                </div>
            </div>
        );
    }

    // ======================================================
    // RENDER
    // ======================================================

    return (
        <>
            <GoogleMap
                mapContainerStyle={
                    mapContainerStyle
                }
                options={{
                    styles: grayStyles,
                    disableDefaultUI: true,
                }}
                onLoad={onMapLoad}
            >
                {locations?.map(
                    (
                        location,
                        index
                    ) => (
                        <MarkerF
                            key={index}
                            position={{
                                lat: location.lat,
                                lng: location.lng,
                            }}
                            icon={icon}
                            onClick={() =>
                                setActiveMarker(
                                    (prev) => (prev === index ? null : index)
                                )}
                        >
                            {activeMarker === index && (
                                <InfoWindowF
                                    position={{
                                            lat: location.lat,
                                            lng: location.lng,
                                        }}
                                        onCloseClick={() =>
                                            setActiveMarker(
                                                null
                                            )
                                        }
                                    >
                                        <div>
                                            <svg onClick={() => setActiveMarker(null)} style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', width: '16px', height: '16px', zIndex: '99', cursor: 'pointer' }} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                                <rect y="1.80957" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 0 1.80957)" fill={markerColor === "blue" ? 'var(--blue)' : 'var(--orange)'} />
                                                <rect x="23.5391" width="2.56" height="33.28" rx="1.28" transform="rotate(45 23.5391 0)" fill={markerColor === "blue" ? 'var(--blue)' : 'var(--orange)'} />
                                            </svg>

                                            <Link
                                                to={`/${location.pageTemplate.toLowerCase()}/${location.slug}`}
                                                style={{ display: 'flex', gap: '1rem' }}
                                                className="map-link"
                                            >
                                                {location.image && (
                                                    <img
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "50%",
                                                            border: "3px solid #fff",
                                                            marginLeft: "-3rem"
                                                        }}
                                                        src={
                                                            location.image
                                                        }
                                                        alt=""
                                                    />
                                                )}

                                                {location.address && (
                                                    <p
                                                        style={{
                                                            fontSize:
                                                                localAddress
                                                                    ? "20px"
                                                                    : "17px",

                                                            marginBottom:
                                                                "0.5rem",

                                                            color:
                                                                localAddress
                                                                    ? "var(--orange)"
                                                                    : "#000",

                                                            fontFamily:
                                                                "var(--manrope)",
                                                        }}
                                                    >
                                                        <strong className={`address-text ${markerColor === "blue" ? "blue" : "orange"}-line`}>
                                                            {
                                                                location.address
                                                            }
                                                        </strong>
                                                        <br />

                                                        <span style={{ fontSize: '13px', display: 'inline-block', lineHeight: '1.5', marginTop: '0.5rem' }}>
                                                            {location?.description?.split("\n").map((line, index) => (
                                                                <React.Fragment key={index}>
                                                                    {line}
                                                                    <br />
                                                                </React.Fragment>
                                                            ))}
                                                        </span>
                                                    </p>
                                                )}
                                            </Link>
                                            {location?.Titel_Text?.length > 0 && <div className="d-flex justify-content-between map-content" style={{ gap: '1rem', marginTop: '0.5rem', borderTop: '1px solid #EFEFEF', paddingTop: '1rem' }}>
                                                {location?.Titel_Text?.map((item, idx) => (
                                                    <div className="item">
                                                        <p style={{ marginBottom: '0.5rem' }}><strong>{item?.Titel}</strong></p>
                                                        <p>
                                                            {item?.Text?.split("\n").map((line, index) => (
                                                                <React.Fragment key={index}>
                                                                    {line}
                                                                    <br />
                                                                </React.Fragment>
                                                            ))}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>}
                                        </div>
                                    </InfoWindowF>
                                )}
                        </MarkerF>
                    )
                )}
            </GoogleMap>

            {/* Loader CSS */}
            <style>{`
                .spinner {
                    width: 55px;
                    height: 55px;
                    border: 4px solid #ddd;
                    border-top: 4px solid #009fe3;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    100% {
                        transform: rotate(360deg);
                    }
                }
            `}</style>
        </>
    );
};

export default MapComponent;